import { render, staticRenderFns } from "./GestaoVendas.vue?vue&type=template&id=2d7e7ff7&scoped=true&"
import script from "./GestaoVendas.vue?vue&type=script&lang=js&"
export * from "./GestaoVendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7e7ff7",
  null
  
)

export default component.exports